import { Component, OnInit, Input, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SystemSelectService } from '../../system-select/system-select.service';
import { ToolDescriptionService, ToolService, KitService, WorkflowStartService, RequestProcessService, SystemService } from '../../camtl.service';
import { Tool } from '../../../../shared/model';
import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';
import { State } from '@progress/kendo-data-query';

import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { RouteValidationService } from "../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { cgpAuthentication } from '../../../../../modules/cgp-authentication';
import { AuthenticationService } from '../../../../../app/auth.service';
import { parseDate } from '@progress/kendo-angular-intl';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  //styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {

  constructor(private service: ToolService,
    private workflowStartService: WorkflowStartService,
    private systemSelectService: SystemSelectService,
    private formBuilder: FormBuilder,
    private kitService: KitService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private routeValidationService: RouteValidationService,
    private authService: AuthenticationService,
    private requestProcessService: RequestProcessService,
    private systemService: SystemService) {
    this.isAdmin = authService.isClaimValid("/MESC/CAMTL/Administration")
  }

  @Input() systemLayoutCount: number = 0;
  @Input() cellsCount: number = 0;
  @Input() stationsCount: number = 0;
  @Input() kitsCount: number = 0;
  @Input() unassignedToolsCount: number = 0;
  @Input() assignedToolsCount: number = 0;

  @Output() cancel: EventEmitter<any> = new EventEmitter();


  system: any;
  editForm: FormGroup;
  editDataItem: Tool;
  showCopyToolsWindow: boolean;
  showSubmitForApprovalWindow: boolean;
  disableToolbar: boolean = false;
  isAdmin: boolean = false;
  submitAsCols: boolean = false;

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;


  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.editForm = this.formBuilder.group({
      Id: [],
      CreatedBy: [],
      CreatedDate: [],
      SystemId: [""],
      CellNumber: [""],
      ToolTypeId: [0],
      ParentId: [0],
      ToolDescriptionId: [0],
      ToolDescription: [""],
      DisplayDescription: [""],
      ToolNumber: [""],
      DisplayNumber: [""],
      KitNumber: [],
      LeftCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      RightCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      SingleCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      DesignEndDate: [new Date()],
      DockDate: [new Date()],
      Pcbom: [""],
      Integration: [false],
      WireDesign: [""],
      Cancelled: [false],
      ActualDesignEndDate: [new Date()],
      ActualDockDate: [new Date()],
      EstimateDollars: [0],
      MakeFurnish: [""],
      AdditionalInfo: [""],
      StationNumber: [""],
      LocationNumber: [0],
      ConstructionHours: [],
      IntegrationHours: [],
      ConstructionHrs: [0],
      IntegrationHrs: [0],
      ResourceLevel: [{}],
      JobNumber: [""],
      ToolDetail: [{}],
      KitDescriptionId: [""],
      SystemLayoutToolId: []
    })

    var self = this;
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/List')) {
          self.setCounts();
          if (this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
            this.template.controls.edit = false;
            this.disableToolbar = true;
          }
          else {
            this.template.controls.edit = true;
            this.disableToolbar = false;
            this.requestProcessService.read("/request/" + this.system.Id, true, false);
          }
        }
        else {
          self.systemLayoutCount = 0;
          self.cellsCount = 0;
          self.stationsCount = 0;
          self.kitsCount = 0;
          self.unassignedToolsCount = 0;
          self.assignedToolsCount = 0;
        }
      });

    this.systemSelectService.get();
  }

  ngOnChanges() {
    var self = this;
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/List')) {
          self.setCounts();
          if (this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
            this.template.controls.edit = false;
            this.disableToolbar = true;
          }
          else {
            this.template.controls.edit = true;
            this.disableToolbar = false;
            this.requestProcessService.read("/request/" + this.system.Id, true, false);
          }
        }
        else {
          self.systemLayoutCount = 0;
          self.cellsCount = 0;
          self.stationsCount = 0;
          self.kitsCount = 0;
          self.unassignedToolsCount = 0;
          self.assignedToolsCount = 0;
        }
      });
    this.systemSelectService.get();
  }

  setCounts() {
    var self = this;
    this.service.read("/listview/" + this.system.Id, true).then(function (response: any[]) {
      self.systemLayoutCount = response.filter(function (tool) {
        return tool.ToolTypeName !== null && tool.ToolTypeName.toUpperCase() === "SYSTEM LAYOUT";
      }).length;

      self.cellsCount = response.filter(function (tool) {
        return tool.ToolTypeName !== null && tool.ToolTypeName.toUpperCase() === "CELL";
      }).length;

      self.kitsCount = response.filter(function (tool) {
        return tool.KitNumber !== null;
      }).length;

      self.assignedToolsCount = response.filter(function (tool) {
        return tool.ToolTypeName !== null && (tool.ToolTypeName.toUpperCase() === "TOOL" || tool.ToolTypeName.toUpperCase() === "FURNISHED EQUIPMENT" || tool.ToolTypeName.toUpperCase() === "LEGACY TOOL") && tool.ParentId !== null;
      }).length;
    });

    this.service.read("/unassigned/count/" + this.system.Id, true).then(function (response) {
      self.unassignedToolsCount = response;
    });

    this.service.read("/system/" + this.system.Id, true).then(function (response: any[]) {
      self.stationsCount = response.filter(function (tool) {
        return tool.ToolTypeName !== null && tool.ToolTypeName.toUpperCase() === "STATION";
      }).length;
    })
  }

  setUnassignedRed = (value) => {
    if (value === "N/A") {
      return 'cgp-red';
    }

    return '';
  }

  gridState: State = {
    skip: 0,
    take: 10,
  };

  private columns: any[] = [
    {
      field: "JobNumber",
      title: "Job No.",
      width: 80
    },
    {
      field: "CellNumber",
      title: "Cell No.",
      width: 95
    },
    {
      field: "StationNumber",
      title: "Station No.",
      width: 100
    },
    {
      field: "DisplayNumber",
      title: "Tool Number",
      width: 125
    },
    {
      field: "DisplayDescription",
      title: "Description",
      width: 220
    },
    {
      field: "DesignEndDate",
      title: "Design End Date",
      width: 135,
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }
    },
    {
      field: "DockDate",
      title: "Dock Date",
      width: 105,
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }
    },
    {
      field: "ConstructionHours",
      title: "Const. Hrs",
      width: 95
    },
    {
      field: "IntegrationHours",
      title: "Integ. Hrs",
      width: 90
    },
    {
      field: "EstimateDollars",
      title: "Material Cost",
      width: 110
    },
    {
      field: "Pcbom",
      title: "PCB",
      width: 80,
      template: {
        type: "customStyle",
        setClass: this.setUnassignedRed
      }
    },
    {
      field: "Integration",
      title: "INT",
      template: {
        type: "boolean",
        onLabel: "True",
        offLabel: "False"
      },
      width: 80
    },
    {
      field: "WireDesign",
      title: "WD",
      width: 80,
      template: {
        type: "customStyle",
        setClass: this.setUnassignedRed
      }
    },
    {
      field: "Canceled",
      title: "CAN",
      template: {
        type: "boolean",
        onLabel: "True",
        offLabel: "False"
      },
      width: 80
    },
    {
      field: "RightCount",
      title: '',
      width: 0
    },

    {
      field: "LeftCount",
      title: '',
      width: 0
    },

    {
      field: "SingleCount",
      title: '',
      width: 0
    },

  ];

  private formDialog = {
    title: '',
    tabs: [
      {
        title: "Read Only",
        selected: true,
        columnClass: 'flex-wrap-column col-size-4',
        formControls: [
          {
            type: 'shortText',
            readonly: 'always',
            title: 'Job Number',
            name: 'JobNumber'
          },
          {
            type: 'shortText',
            readonly: 'always',
            title: 'Cell Number',
            name: 'CellNumber'
          },
          {
            type: 'shortText',
            readonly: 'always',
            title: 'Location Number',
            name: 'LocationNumber'
          },
          {
            type: 'shortText',
            name: 'LeftCount',
            title: 'LH',
            readonly: 'always',
            width: 50
          },
          {
            type: 'shortText',
            name: 'SingleCount',
            title: 'S',
            readonly: 'always',
            width: 50
          },
          {
            type: 'shortText',
            readonly: 'always',
            title: 'Tool Number',
            name: 'DisplayNumber'
          },
          {
            type: 'shortText',
            readonly: 'always',
            title: 'Station Number',
            name: 'StationNumber'
          },
          {
            type: 'shortText',
            readonly: 'always',
            title: 'Description',
            name: 'DisplayDescription'
          },
          {
            type: 'shortText',
            name: 'RightCount',
            title: 'RH',
            readonly: 'always',
            width: 50
          },
          {
            type: 'text',
            readonly: 'always',
            title: 'Additional Info',
            name: 'AdditionalInfo'
          },
        ]
      },
      {
        title: 'Editable',
        columnClass: 'flex-wrap-column col-size-5',
        formControls: [
          {
            type: 'date',
            name: 'DesignEndDate',
            title: 'Design End Date',
            format: 'MM/dd/yyyy'
          },
          {
            type: 'number',
            name: 'ConstructionHours',
            title: 'Construction Hours',
            minimum: 0,
            step: 1
          },
          {
            type: 'number',
            name: 'EstimateDollars',
            title: 'Material Cost ($)',
            minimum: 0,
            step: 1
          },
          {
            type: 'presetCombobox',
            name: 'Pcbom',
            title: 'PCB',
            placeholder: 'Select PCB',
            textField: 'value',
            valueField: 'value',
            data: [
              { "value": "True" },
              { "value": "False" }
            ]
          },
          {
            type: 'boolean',
            name: 'Integration',
            title: 'INT'
          },
          {
            type: 'presetCombobox',
            name: 'MakeFurnish',
            title: 'M/F',
            placeholder: 'M/F',
            textField: 'value',
            valueField: 'value',
            data: [
              { "value": "M" },
              { "value": "F" }
            ]
          },
          {
            type: 'date',
            name: 'DockDate',
            title: 'Dock Date',
            format: 'MM/dd/yyyy'
          },
          {
            type: 'number',
            name: 'IntegrationHours',
            title: 'Integration Hours',
            minimum: 0,
            step: 1,
          },
          {
            type: 'presetCombobox',
            name: 'ResourceLevel',
            title: 'Resource Level',
            placeholder: 'Select a Resource Level',
            textField: 'value',
            valueField: 'value',
            data: [
              { "value": 1 },
              { "value": 2 },
              { "value": 3 },
              { "value": 3.5 }
            ]
          },
          {
            type: 'presetCombobox',
            name: 'WireDesign',
            title: 'WD',
            placeholder: 'Select Wire Design',
            textField: 'value',
            valueField: 'value',
            data: [
              { "value": "True" },
              { "value": "False" }
            ]
          },
          {
            type: 'boolean',
            name: 'Cancelled',
            title: 'CAN'
          }
        ]
      }
    ]
  }

  onRead = () => {
    //Set DisplayDescription, DisplayNumber, DesignEndDate, and Dock Date
    return this.service.read("/listview/" + this.system.Id, true).then(function (response) {
      for (var i = 0; i < response.length; i++) {
        if (response[i].ToolDetail !== null) {
          response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;
          response[i]["DesignEndDate"] = response[i].ToolDetail.DesignEndDate;
          response[i]["DockDate"] = response[i].ToolDetail.DockDate;
          response[i]["ActualDesignEndDate"] = response[i].ToolDetail.ActualDesignEndDate;
          response[i]["ActualDockDate"] = response[i].ToolDetail.ActualDockDate;
          response[i]["DisplayDescription"] = response[i].ToolDescription;
          response[i]["ConstructionHours"] = response[i].ToolDetail.ConstructionHrs;
          response[i]["IntegrationHours"] = response[i].ToolDetail.IntegrationHrs;
          response[i]["ResourceLevel"] = response[i].ToolDetail.ResourceLevel;
          response[i]["EstimateDollars"] = response[i].ToolDetail.EstimateDollars;
          response[i]["Pcbom"] = response[i].ToolDetail.PcBom;
          response[i]["WireDesign"] = response[i].ToolDetail.WireDesign;
          response[i]["Cancelled"] = response[i].ToolDetail.IsCancelled;
          response[i]["Integration"] = response[i].ToolDetail.IsIntegration;
        }
        else if (response[i].KitNumber && response[i].KitNumber !== null) {
          response[i]["DisplayNumber"] = response[i].KitNumber;
          response[i]["DisplayDescription"] = response[i].KitDescriptionName;
          response[i]["JobNumber"] = response[i].KitJobNumber;

        }

        if (response[i].LegacyToolDescription !== null) {
          response[i]["DisplayDescription"] = response[i].LegacyToolDescription;
        }

        if (response[i].Pcbom === null) {
          response[i].Pcbom = "N/A";
        }

        if (response[i].Pcbom === "0") {
          response[i].Pcbom = "False";
        }

        if (response[i].Pcbom === "1") {
          response[i].Pcbom = "True";
        }

        if (response[i].WireDesign === null) {
          response[i].WireDesign = "N/A";
        }

        if (response[i].WireDesign === "0") {
          response[i].WireDesign = "False";
        }

        if (response[i].WireDesign === "1") {
          response[i].WireDesign = "True";
        }

        if (response[i]["DesignEndDate"] !== null) {
          response[i]["DesignEndDate"] = response[i]["DesignEndDate"].toString().split("T")[0];
        }

        if (response[i]["DockDate"] !== null) {
          response[i]["DockDate"] = response[i]["DockDate"].toString().split("T")[0];
        }

      }

      return response;
    });
  }

  onEdit(object) {
    (object.dataItem.DesignEndDate && object.dataItem.DesignEndDate !== null) ? object.dataItem.DesignEndDate = parseDate(object.dataItem.DesignEndDate) : object.dataItem.DesignEndDate = new Date();
    (object.dataItem.DockDate && object.dataItem.DockDate !== null) ? object.dataItem.DockDate = parseDate(object.dataItem.DockDate) : object.dataItem.DockDate = new Date();
    (object.dataItem.ActualDesignEndDate && object.dataItem.ActualDesignEndDate !== null) ? object.dataItem.ActualDesignEndDate = parseDate(object.dataItem.ActualDesignEndDate) : object.dataItem.ActualDesignEndDate = new Date();
    (object.dataItem.ActualDockDate && object.dataItem.ActualDockDate !== null) ? object.dataItem.ActualDockDate = parseDate(object.dataItem.ActualDockDate) : object.dataItem.ActualDockDate = new Date();
  }

  onSave = (dataItem, isNew) => {
    var self = this;
    if (dataItem.KitNumber === null) {
      dataItem.ToolDetail.ConstructionHrs = dataItem.ConstructionHours;
      dataItem.ToolDetail.IntegrationHrs = dataItem.IntegrationHours;
      dataItem.ToolDetail.ResourceLevel = dataItem.ResourceLevel;
      dataItem.ToolDetail.EstimateDollars = dataItem.EstimateDollars;
      dataItem.ToolDetail.DesignEndDate = dataItem.DesignEndDate;
      dataItem.ToolDetail.DockDate = dataItem.DockDate;
      dataItem.ToolDetail.ActualDesignEndDate = dataItem.ActualDesignEndDate;
      dataItem.ToolDetail.ActualDockDate = dataItem.ActualDockDate;
      dataItem.ToolDetail.Pcbom = dataItem.Pcbom;
      dataItem.ToolDetail.IsIntegration = dataItem.Integration;
      dataItem.ToolDetail.WireDesign = dataItem.WireDesign;
      dataItem.ToolDetail.IsCancelled = dataItem.Cancelled;

      dataItem = dataItem.ToolDetail;
      this.service.save(dataItem, isNew, "Detail", false, false).then(function () {
        self.setCounts();
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: "Record has been updated",
          duration: 2000
        })
      })
    }
    else {
      this.kitService.save(dataItem, isNew, "", false, false).then(function () {
        self.setCounts();
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: "Record has been updated",
          duration: 2000
        })
      })
    }
  }

  copyTools = (e, service, system) => {
    this.showCopyToolsWindow = true;
  }


  submitForApproval = (e, service, system) => {
    this.showSubmitForApprovalWindow = true;
  }

  saveCopyTools(dataItems) {
    var self = this;
    for (var i = 0; i < dataItems.length; i++) {
      if (dataItems[i].SystemId === this.system.Id) {
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: "Cannot copy tools to the same system",
          alert: "danger",
          closeLabel: "OK"
        })
        break;
      }
      this.service.save({}, true, "/" + this.system.Id + "/copy/" + dataItems[i].Id, false, false).then(function () {
        if (i === dataItems.length) {
          self.showCopyToolsWindow = false;
          self.cgpSnackbarService.showSnackbar({
            message: i === 1 ? "Tool has been copied" : "Tools have been copied",
            duration: 2000
          });
          self.setCounts();
          self.grid.refresh(true);
        }
      });
    }
  }

  cancelCopyTools(e) {
    this.showCopyToolsWindow = false;
  }

  customToolbarButtons = [
    {
      id: 'copyTools',
      iconClass: 'fa fa-copy',
      title: 'Copy Tools to System',
      text: 'Copy Tools to System',
      callback: this.copyTools
    },
    {
      id: 'submitForApproval',
      iconClass: 'fa fa-copy',
      title: 'Submit for Approval',
      text: 'Submit for Approval',
      callback: this.submitForApproval
    }
  ]

  isDisabled = (id) => {
    switch (id) {
      case "copyTools":
      case "submitForApproval":
        return this.disableToolbar;
      default:
        return false;
    }
  }

  template = {
    title: 'Tool',
    controls: {
      add: false,
      edit: true,
      delete: false,
      excel: true,
      width: 65,
      customToolbar: this.customToolbarButtons,
      isDisabled: this.isDisabled
    },
    fileName: 'tool_list.xlsx',
    columns: this.columns,
    service: this.service,
    read: this.onRead,
    save: this.onSave
  }

  setModelHandler() {
    this.editDataItem = new Tool();

    if (this.system) {
      this.editDataItem.SystemId = this.system.Id;
    }
  }

  onCancel(e) {
    e.preventDefault();
    this.onClose();
  }

  onClose() {
    this.showSubmitForApprovalWindow = false;
    this.cancel.emit();
  }

  onSaveAllocation(e, submissionComments) {

    var self = this;
    let jsonInput: any = {
      SystemId: this.system.Id,
      IsColsAdmin: this.submitAsCols,
      Requestor: cgpAuthentication.getUserInfo().mail,
      AllocationNotes: submissionComments
    }

    this.workflowStartService.save(jsonInput, true, "", false, false).then(function () {
      self.cgpSnackbarService.showSnackbar({
        message: "System " + self.system.SystemNumber + " has been submitted for approval"
      });
      self.submitAsCols = false;
      self.systemService.read("/" + self.system.Id, true).then(function (response) {
        self.systemSelectService.system.next(response);
        if (self.system.AllocationStatus !== null && self.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
          self.template.controls.edit = false;
          self.disableToolbar = true;
        }
        else {
          self.template.controls.edit = true;
          self.disableToolbar = false;
          self.requestProcessService.read("/request/" + self.system.Id, true, false);
        }
      })
    }).catch(function (response) {
      try {
        var errors = JSON.parse(response._body);
        var errorList = document.createElement('ul');

        for (var i = 0; i < errors["errors"].length; i++) {
          var childList = document.createElement('li');
          childList.innerHTML = errors["errors"][i].replace(/"/g, '');
          errorList.appendChild(childList);
        }
        //console.log(errorList);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: errorList.outerHTML,
          alert: 'danger',
          closeLabel: 'OK'
        })
      } catch (error) {
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response.error.ExceptionMessage,
          alert: 'danger',
          closeLabel: 'OK'
        })
      }
    });

    this.showSubmitForApprovalWindow = false;
    this.cancel.emit();
  }

  revisionColumns = [
    {
      field: 'RevisionNumber',
      title: "Revision #",
      width: 90
    },
    {
      field: 'ContactName',
      title: 'Requestor',
      width: 175
    },
    {
      field: 'ModifiedDate',
      title: 'Revised On',
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      },
      width: 115
    },
    {
      field: 'AllocationNotes',
      title: 'Allocation Notes'
    }
  ]

  handleTemplateRead = () => {
    return this.requestProcessService.read("/request/" + this.system.Id, true);
  }

  revisionTemplate = {
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: true
    },
    fileName: "revision_history.xlsx",
    columns: this.revisionColumns,
    read: this.handleTemplateRead
  }

}
